import type { PropertyResearchRepository } from "../types";
import research from "../../public/properties/west-dixie/research.json";

/**
 * The property repository owns the evidence record. Keeping this adapter tiny
 * makes the same versioned JSON drive the Beacon UI and the generated report.
 */
export const westDixieResearch = research as PropertyResearchRepository;
